import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import ApiService from "../../services/apiService";
import { method } from "lodash";
import DateTimePicker from "react-datepicker";
import Table from "../table/Table";
import { toast } from "react-toastify";
import { usePagination } from "../../hooks/usePagination";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import { format } from "date-fns";
import { color } from "highcharts";
import LeftIcon from "../svg/LeftButton";
import RightIcon from "../svg/RightIcon";
import ExportExcel from "../reports/ExportExcel";
const GetReportPumpingStation = () => {
  const [fromDateTime, setFromDateTime] = useState(null);
  const [toDateTime, setToDateTime] = useState(null);
  const [pumpingStationHistory, setPumpingStationHistory] = useState<any[]>();
  const navigate = useNavigate();
  let updatedData: any = [];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [selectedStationName, setSelectedStationName] = useState<any>(null);
  const [pumpingStationData, setpumpingStationData] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number | string>();
  const [refreshKey, setRefreshKey] = useState();

  useEffect(() => {
    const getPumpingStation = async () => {
      try {
        const response = await ApiService.axiosApi(`/pumpingstation`, {
          method: "GET",
          params: {
            pageNumber: 0,
            pageSize: 0,
          },
        });
        if (response.success) {
          setpumpingStationData(response.data.data);
        } else {
          console.log(
            response.status ||
              response.message ||
              "Unable to get Pumping Station"
          );
        }
      } catch (error) {
        console.log(error);
      }
    };

    getPumpingStation();
  }, []);

  const {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    setFromDate,
    setToDate,
    setId,
    id,
    setPumpingStationId,
    fromDate,
    toDate,
  } = usePagination({
    endpoint: `/pumpingstation/history`,
    refreshKey,
    enabled: isEnabled,
  });

  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
    setPageNumber((prev) => Math.min(totalPages, prev + 1));
  }, [setPageNumber, totalPages]);

  const handlePrev = useCallback(() => {
    setPageNumber((prev) => Math.max(1, prev - 1));
  }, [setPageNumber, totalPages]);

  const handleClick = () => {
    if (!validateGenerate()) return;

    if (fromDateTime) {
      const from = format(fromDateTime, "yyyy-MM-dd HH:mm:ss");
      setFromDate(from);
    }

    if (toDateTime) {
      const to = format(toDateTime, "yyyy-MM-dd HH:mm:ss");
      setToDate(to);
    }

    setIsEnabled(true);
    setRefresh((prev) => !prev);
  };

  const handleDelete = (id: string) => {
    setDeleteId(id);
    setIsModalOpen(true);
  };

  const handleEdit = (id: string) => {
    navigate(`/pumping-history-update/${id}`);
  };

  const handleDeleteConfirm = async (id: string | number | undefined) => {
    try {
      const response = await ApiService.axiosApi(
        `/pumpingstation/history${id}`,
        {
          method: "DELETE",
        }
      );
      if (response.success) {
        toast.success("Report Deleted Successfully");
        setRefresh((refresh) => !refresh);
        setIsModalOpen(false);
      } else {
        toast.error("Unable To Delete Report");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllDataForExport = async () => {
    try {
      const response = await ApiService.axiosApi(`/pumpingstation/history`, {
        method: "GET",
        params: {
          pageNumber: 0,
          pageSize: 0,

          fromDate: fromDate,
          toDate: toDate,
          // <-- fetch ALL rows
        },
      });

      if (response.success) {
        return response.data.data;
      } else {
        toast.error("Unable to fetch full report");
        return [];
      }
    } catch (error) {
      console.log(error);
      toast.error("API Error");
      return [];
    }
  };
  if (data) {
    updatedData = data.map((data) => {
      return {
        ...data,
        dateTime: format(new Date(data.dateTime), "dd-MM-yyyy HH:mm:ss"),
      };
    });
  }

  const validateGenerate = () => {
    if (!fromDateTime) {
      toast.warning("Please select From Date");
      return false;
    }

    if (!toDateTime) {
      toast.warning("Please select To Date");
      return false;
    }

    if (new Date(fromDateTime) > new Date(toDateTime)) {
      toast.warning("From Date cannot be greater than To Date");
      return false;
    }

    return true;
  };
  return (
    <>
      <Breadcrumbs mainTitle="PumpingStation" parent="Get Volume Report " />
      <div className="w-100 bg-white px-2 py-2">
        <div
          className="bg-light-primary "
          style={{
            width: "100%",
            height: "100px",
            border: "1px solid rgb(43, 94, 94, 0.1)",
          }}
        >
          <div className="report-header d-flex d-flex justify-content-around align-items-center">
            <div className="d-flex stationvolumereport-dropdowndatetime justify-content-evenly align-items-center">
              <div
                className=" mx-4 input-border d-flex flex-column "
                style={{ width: "50%" }}
              >
                <Label>From Date:</Label>
                <DateTimePicker
                  className="stationvolumereport-fromdate"
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  placeholderText="DD-MM-YYYY"
                  showTimeSelect
                  onChange={(date: any) => setFromDateTime(date)}
                  selected={fromDateTime}
                  isClearable
                  timeFormat="HH:mm:ss"
                />
              </div>

              <div
                className=" mx-4  input-border  d-flex flex-column"
                style={{ width: "50%" }}
              >
                <Label>To Date:</Label>
                <DateTimePicker
                  className="stationvolumereport-todate"
                  dateFormat="dd/MM/yyyy HH:mm:ss"
                  placeholderText="DD-MM-YYYY"
                  showTimeSelect
                  onChange={(date: any) => setToDateTime(date)}
                  selected={toDateTime}
                  isClearable
                  timeFormat="HH:mm:ss"
                />
              </div>
            </div>
            <div className="volumestation-buttonclass d-flex gap-3">
              <div className=" d-flex flex-column" style={{ width: "30%" }}>
                <Label style={{ visibility: "hidden" }}>Generate</Label>
                <Button
                  className="px-0"
                  color="success"
                  onClick={handleClick}
                  style={{ width: "100%" }}
                >
                  Generate
                </Button>
              </div>

              <div className=" d-flex flex-column" style={{ width: "30%" }}>
                <Label style={{ visibility: "hidden" }}>Generate</Label>
                <Button
                  className="px-0"
                  style={{ width: "100%" }}
                  onClick={() => navigate(`/pumping-history-add`)}
                  color="primary"
                >
                  Add
                </Button>
              </div>

              <ExportExcel
                getData={fetchAllDataForExport}
                fileName="Station_Volume_Report"
                style={{ width: "30%" }}
                hiddenColumns={["id", "name", "pumpNumber", "distribution"]}
                EffectiveFrom={fromDate}
                toDate={toDate}
              />
            </div>
          </div>
        </div>

        <div className="mt-2">
          <Table
            isAction={true}
            data={updatedData}
            columns={[
              { header: "Date&Time", accessor: "dateTime" },

              { header: "Volume", accessor: "dailyVolume" },
            ]}
            buttons={[
              {
                label: "Edit",
                onClick: handleEdit,
                color: "primary",
                className: "me-2",
              },
              { label: "Delete", onClick: handleDelete, color: "danger" },
            ]}
          />

          <div
            className=" d-flex justify-content-end align-content-center"
            style={{ marginRight: "10px", marginTop: "10px" }}
          >
            <p style={{ marginRight: "10px", marginTop: "8px" }}>
              Page {pageNumber} of {totalPages}
            </p>
            <button
              onClick={handlePrev}
              disabled={pageNumber === 1}
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
            >
              <LeftIcon className="icon" />
            </button>
            <button
              className={`icon-button ${
                pageNumber === totalPages ? "disabled" : ""
              }`}
              onClick={handleNext}
              disabled={pageNumber === totalPages}
            >
              <RightIcon className="icon" />
            </button>
          </div>
        </div>

        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(!isModalOpen)}>
          <ModalHeader>
            <h3>Delete Volume Report</h3>
          </ModalHeader>
          <ModalBody>
            <h5> Are You Sure You Want To Delete This Volume Report</h5>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => handleDeleteConfirm(deleteId)}
              color="danger"
            >
              Delete
            </Button>
            <Button onClick={() => setIsModalOpen(false)} color="primary">
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default GetReportPumpingStation;
